import { render, staticRenderFns } from "./update-tip.vue?vue&type=template&id=55f6a746&scoped=true&"
import script from "./update-tip.vue?vue&type=script&lang=js&"
export * from "./update-tip.vue?vue&type=script&lang=js&"
import style0 from "./update-tip.vue?vue&type=style&index=0&id=55f6a746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f6a746",
  null
  
)

export default component.exports